module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/dark/dark.component.css
// module id = ./src/app/examples/dark/dark.component.css
// module chunks = main